import React, { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import instance from './app/axiosInstance';
import initializeApp from './app/init';
import { pdfjs } from "react-pdf";

// Importing pages

const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const OtpPage = lazy(() => import('./pages/OtpPageVefification'))
const OtpChangePassword = lazy(() => import('./pages/OtpChangePasswordVerification'))
const Register = lazy(() => import('./pages/Register'))
const Documentation = lazy(() => import('./pages/Documentation'))
const HomePageWeb = lazy(() => import('./pages/HomePageWeb'))
const HomeSyaratKetentuan = lazy(() => import('./pages/SyaratKetentuan'))
const HomeDowbloadFile = lazy(() => import('./pages/DownloadFile'))
const HomeContact = lazy(() => import('./pages/Contact'))
const HomeSearch = lazy(() => import('./pages/Search'))
const Verificationpage = lazy(() => import('./pages/Verificationpage'))
const Information = lazy(() => import('./pages/Information'))
const ChangePasswordPage = lazy(() => import('./pages/ChangePasswordPage'))
const UnderMaintenance = lazy(() => import('./pages/UnderMaintenance')) 
const GProcLandingPage = lazy(() => import('./pages/GProcLandingPage'))

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

//instance()
// Initializing different libraries
initializeApp()

// Check for login and initialize axios
const token = checkAuth()

//console.log(token);

function App() {

  useEffect(() => {
    themeChange(false)
  }, [])


  return (
    <>
      <Router>
        <Routes>
          <Route path="/home-page" element={<HomePageWeb />} />
          <Route path="/syarat-ketentuan" element={<HomeSyaratKetentuan />} />
          <Route path="/information" element={<Information />} />
          <Route path="/download" element={<HomeDowbloadFile />} />
          <Route path="/contact" element={<HomeContact />} />
          <Route path="/search" element={<HomeSearch />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/verificationpage" element={<Verificationpage />} />
          <Route path="/otp-page" element={<OtpPage />} />
          <Route path="/otp-change-password" element={<OtpChangePassword />} />
          <Route path="/page-change-password" element={<ChangePasswordPage />} />
          <Route path="/under-maintenance" element={<UnderMaintenance />} />
          <Route path="/tender-management" element={<GProcLandingPage />} />
          
          <Route path="/app/*" element={<Layout />} />
          <Route path="*" element={<Navigate to="/home-page" replace />}/>

          {/*<Route path="*" element={<UnderMaintenance />} />*/}

        </Routes>
      </Router>
    </>
  )
}

export default App
